<template>
  <div class="w-full">
    <div class="gap-5 mt-6 block md:flex">
      <inputIcon :iconRight="true">
        <input
          id="search"
          class="w-full"
          type="text"
          name="search"
          placeholder="Search"
          v-model="search"
          slot="icon"
        />

        <SearchIcon class="absolute mx-2 text-gray-500" slot="input" />
      </inputIcon>
      <multiselect
        v-model="categorySelected"
        track-by="name"
        label="text"
        class="md:py-0 py-2"
        :options="categories"
        :searchable="false"
        :allow-empty="true"
      >
      </multiselect>

      <multiselect
        v-model="orderSelected"
        track-by="name"
        label="text"
        class="md:py-0 py-2"
        :options="sort_options"
        :searchable="false"
        :allow-empty="false"
      ></multiselect>
    </div>

    <div class="flex flex-col justify-start mt-5">
      <div v-if="errorsExists">
        <p class="mt-3 text-4xl font-bold leading-8 text-gray-900 sm:mt-4">
          There are no results.
        </p>
        <p class="mt-3 text-base leading-7 text-gray-900 sm:mt-4">
          Please, try different <b>search</b> words.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import inputIcon from "./inputIcon.vue";
import { SearchIcon } from "@vue-hero-icons/outline";

export default {
  props: {
    errorsExists: Boolean,
    type: String,
    input: String
  },

  components: { inputIcon, SearchIcon },

  data() {
    return {
      orderSelected: { name: "DESC", text: "Sort by latest" },
      categorySelected: { name: "all", text: "All Categories" },
      sort_options: [
        { name: "DESC", text: "Sort by latest" },
        { name: "ASC", text: "Sort by oldest" },
      ],
      categories: [],
      search: this.input,
    };
  },
  created() {
    this.getCategories();
  },
  methods: {
    getCategories() {
      this.axios.get(`/categories?type=${this.type}`).then((response) => {
        this.categories = [this.categorySelected, ...response.data];
      });
    },
    getDataParent() {
      this.$emit(
        "getData",
        1,
        this.orderSelected.name,
        this.categorySelected.name,
        this.search
      );
    },
  },

  watch: {
    orderSelected() {
      this.getDataParent();
    },
    categorySelected() {
      this.getDataParent();
    },
    search() {
      this.getDataParent();
    },
  },
};
</script>